import React, {useState} from 'react';
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import ForwardIcon from '@mui/icons-material/Forward';
import CloseIcon from '@mui/icons-material/Close';
import Tooltip from '@mui/material/Tooltip';
import {Owner,Bill} from './Inc';
import {Tools} from './Tools';
import BillDetail from './BillDetail';
import Title from './Title';

interface Props {
    bills:Bill[],
    owner:Owner,
}

const BillList = (props:Props)=> {
    const classes = useStyles();
    const [states,setStates] = useState({
        isConfirm: false,
        index: 0,
    });
    const openDetail = (e: React.MouseEvent<HTMLElement>)=>{
        if( e.currentTarget.dataset.index ){
            setStates({...states,isConfirm:true,index:parseInt(e.currentTarget.dataset.index)});
        }
    }
    const closeDetail = ()=>{
        setStates({...states,isConfirm:false});
    }

	return (
		<div id="bill_list" className={classes.root}>
            <Title text="支払履歴" size={2}/>
            <div style={{marginBottom:"2em"}}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tableHeadNowrap} align='center'><Hidden mdDown implementation="js">受付</Hidden>番号</TableCell>
                            <TableCell className={classes.tableHeadNowrap} align='center'>申請日</TableCell>
                            <TableCell className={classes.tableHeadNowrap} align='center' sx={{display:{sm:'table-cell',xs:'none'}}}>商品売上</TableCell>
                            <Hidden lgDown implementation="js">
                            <TableCell className={classes.tableHeadNowrap} align='center'>販売手数料</TableCell>
                            <TableCell className={classes.tableHeadNowrap} align='center'>返送料等</TableCell>
                            <TableCell className={classes.tableHeadNowrap} align='center'>支払手数料</TableCell>
                            </Hidden>
                            <TableCell className={classes.tableHeadNowrap} align='center'>振込金額</TableCell>
                            <Hidden smDown implementation="js">
                            <TableCell className={classes.tableHeadNowrap} align='center'>支払日</TableCell>
							</Hidden>
                            <TableCell className={classes.tableHeadNowrap} align='center'>状態</TableCell>
                            <TableCell className={classes.tableHeadNowrap}>　</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.bills.map((bill:Bill,index:number)=>{
                            const key = "bill"+index;
                            let classStatus = "cl cl-green";
                            if( bill.status==="0" ){
                                classStatus = "cl cl-orange";
                            }
                            return (
                                <TableRow key={key}>
                                    <TableCell className={classes.tableCellNowrap} style={{width:'5em'}} align="center">{bill.bill_id}</TableCell>
                                    <TableCell className={classes.tableCellNowrap} style={{width:'6em'}} align="center">{bill.apply_date}</TableCell>
                                    <TableCell className={classes.tableCellNowrap} align="right" sx={{display:{sm:'table-cell',xs:'none'}}}>{Tools.comma(bill.sales)}</TableCell>
                                    <Hidden lgDown implementation="js">
                                    <TableCell className={classes.tableCellNowrap} align="right">{Tools.comma(bill.fee)}</TableCell>
                                    <TableCell className={classes.tableCellNowrap} align="right">{Tools.comma(bill.fee_etc)}</TableCell>
                                    <TableCell className={classes.tableCellNowrap} align="right">{Tools.comma(bill.cost)}</TableCell>
                                    </Hidden>
                                    <TableCell className={classes.tableCellNowrap} align="right">
                                        {Tools.comma(bill.amount)}
                                    </TableCell>
                                    <Hidden smDown implementation="js">
                                    <TableCell className={classes.tableCellNowrap} style={{width:'6em'}} align="center">
                                        {bill.pay_date && <span>{bill.pay_date}</span>}
                                        {!bill.pay_date && bill.status!=='9' && <span className={classes.mitei}>未定</span>}
										{!bill.pay_date && bill.status==='9' && <span className={classes.funou}>支払不能</span>}
                                    </TableCell>
                                    </Hidden>
                                    <TableCell className={classes.tableCellNowrap} style={{width:'3em'}} align="center">
										{bill.status!=='9' && <span className={classStatus}>{bill.status_label}</span>}
										{bill.status==='9' && <CloseIcon style={{verticalAlign:'middle'}} className={classes.funou}/>}
									</TableCell>
                                    <TableCell className={classes.tableCellNowrap} style={{width:'2em'}} align="center">
                                        <Tooltip title="詳細を見る"><IconButton aria-label="edit" className={classes.primary} onClick={openDetail} data-index={index} style={{margin:'0',padding:'0'}}><ForwardIcon/></IconButton></Tooltip>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
                {props.bills.length===0 &&
                <div style={{textAlign:"center",marginTop:"1em"}}>なし</div>
                }
            </div>
            <BillDetail isOpen={states.isConfirm} close={closeDetail} bill={props.bills[states.index]} owner={props.owner}/>
		</div>
	);
}

export default BillList;
